import React from 'react';

const items = [
  'Guaranteed Rent', 'Zero Void Periods', 'HMO Specialists', 'Fully Managed', 'Fully Compliant', '3–5 Year Contracts',
];

export default function Marquee() {
  const row = [...items, ...items, ...items];
  return (
    <div className="relative border-y border-white/10 bg-[#0f0f10] py-6 md:py-8 overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track">
        {[...row, ...row].map((t, i) => (
          <div key={i} className="flex items-center px-6 md:px-10">
            <span className="serif text-2xl md:text-4xl text-white/85">{t}</span>
            <span className="serif text-2xl md:text-4xl text-[#e4cfaf] ml-6 md:ml-10">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
